@if (config?.labels) {
  <div class="progress-tracker-chart-form">
    <div class="row center full-width">
      <mat-form-field>
        <mat-label>Chart Title</mat-label>
        <input matInput [(ngModel)]="config.labels.title" style="box-sizing: border-box;">
      </mat-form-field>
      <mat-form-field>
        <mat-label>Y Axis Title</mat-label>
        <input matInput [(ngModel)]="config.labels.y_axis" style="box-sizing: border-box;">
      </mat-form-field>
    </div>
    @if (estimateTypes) {
      <div class="row center">
        <select-filter
          [label]="'Estimate type'"
          (constant_changed)="updateColumns($event)"
          [modelValue]="config.estimate_type"
          [options]="estimateTypes"
          [classes]="'fill'"
          class="select-search">
        </select-filter>
        <select-filter
          [label]="'Period Type'"
          (constant_changed)="updatePeriodType($event)"
          [modelValue]="config.period_type"
          [options]="periodTypes"
          [classes]="'fill'"
          class="select-search">
        </select-filter>
      </div>
    }
    <series-summary-column-selector [config]="config" [disabled]="true" [formType]="'chart'" [showMobile]="false"
    [colMenuOptions]="colMenuOptions"></series-summary-column-selector>
    <custom-chart-form-series-table [(series_list)]="config.series_list"
    [chart_type]="'progress tracker'"></custom-chart-form-series-table>
  </div>
}
